export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"World leading supply chain & energy transition intelligence. Lithium, Nickel, Cobalt, Graphite, Batteries, Electric Vehicles, Rare Earths and Permanent Magnets."},{"hid":"og:description","property":"og:description","content":"World leading supply chain & energy transition intelligence. Lithium, Nickel, Cobalt, Graphite, Batteries, Electric Vehicles, Rare Earths and Permanent Magnets."},{"hid":"og:title","property":"og:title","content":"Benchmark Mineral Intelligence"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"Benchmark Mineral Intelligence"},{"hid":"og:image","property":"og:image","content":"https://res.cloudinary.com/benchmarkminerals/image/upload/dpr_auto,f_avif,q_auto,g_auto/v1680641799/assets/social/Benchmark_Logo_LinkedIn_osauqc.png"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"https://res.cloudinary.com/benchmarkminerals/image/upload/dpr_auto,f_avif,q_auto,g_auto/v1680641799/assets/social/Benchmark_Logo_LinkedIn_osauqc.png"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:description","name":"twitter:description","content":"World leading supply chain & energy transition intelligence. Lithium, Nickel, Cobalt, Graphite, Batteries, Electric Vehicles, Rare Earths and Permanent Magnets."},{"hid":"twitter:site","name":"twitter:site","content":"@benchmarkmin"},{"hid":"twitter:creator","name":"twitter:creator","content":"@benchmarkmin"},{"hid":"twitter:image","name":"twitter:image","content":"https://res.cloudinary.com/benchmarkminerals/image/upload/dpr_auto,f_avif,q_auto,g_auto/v1680641859/assets/social/Benchmark_Logo_Twitter_iiosvj.png"},{"hid":"og:url","property":"og:url","content":"https://portal.benchmarkminerals.com"}],"link":[{"rel":"shortcut icon","type":"image/x-icon","href":"https://res.cloudinary.com/benchmarkminerals/image/upload/v1683314281/assets/favicon_abknf6.png"}],"style":[],"script":[{"src":"https://js-eu1.hs-scripts.com/25724218.js","id":"hs-script-loader","type":"text/javascript","defer":true},{"hid":"hubspot","src":"//js-eu1.hsforms.net/forms/embed/v2.js","type":"text/javascript","defer":true},{"src":"https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js","async":true,"defer":true,"type":"text/javascript","id":"hs-meeting-script-loader"},{"src":"https://pl-prx.webdev-e42.workers.dev/portal/script.js","async":true},{"innerHTML":"\n        window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};\n        plausible.init({\n          endpoint: \"https://pl-prx.webdev-e42.workers.dev/portal/event\"\n        })\n    ","type":"text/javascript"},{"id":"gtm-loader","type":"text/javascript","defer":true,"innerHTML":"\n  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','GTM-KP4DFXJ4');\n"}],"noscript":[{"children":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-KP4DFXJ4\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>","type":"text/html","body":true}],"title":"Benchmark Mineral Intelligence","htmlAttrs":{"lang":"en_GB"},"__dangerouslyDisableSanitizers":["script"]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"activeClass":"nuxt-link-active","exactActiveClass":"nuxt-link-exact-active","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true